import api from "./axiosConfig";

// =====================================================================
// (2026-05-21) Estructura de cobranza — API client
// =====================================================================

// --- Reglas de cobro ---

export const getReglasCobro = async (params = {}) => {
  try {
    const response = await api.get("/api/billing/reglas", { params });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) return [];
    console.error("Error al obtener reglas de cobro:", error);
    throw error;
  }
};

export const getReglaCobro = async (id) => {
  try {
    const response = await api.get(`/api/billing/reglas/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al consultar regla:", error);
    throw error;
  }
};

export const createReglaCobro = async (body) => {
  try {
    const response = await api.post("/api/billing/reglas", body);
    return response.data;
  } catch (error) {
    console.error("Error al crear regla:", error);
    throw error;
  }
};

export const updateReglaCobro = async (id, body) => {
  try {
    const response = await api.put(`/api/billing/reglas/${id}`, body);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar regla:", error);
    throw error;
  }
};

export const deleteReglaCobro = async (id) => {
  try {
    // Soft delete: el backend marca estado=False (preserva historial).
    const response = await api.delete(`/api/billing/reglas/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al desactivar regla:", error);
    throw error;
  }
};

// --- Historial de cobranza ---

export const getHistorialCobranza = async (params = {}) => {
  try {
    const response = await api.get("/api/billing/historial", { params });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) return [];
    console.error("Error al obtener historial:", error);
    throw error;
  }
};

export const getHistorialCobranzaDetalle = async (id) => {
  try {
    const response = await api.get(`/api/billing/historial/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al consultar detalle de historial:", error);
    throw error;
  }
};

// Estima el corte SIN persistir (preview).
export const estimarCorteCobranza = async (periodo = null) => {
  try {
    const params = periodo ? { periodo } : {};
    const response = await api.get("/api/billing/historial/estimar", { params });
    return response.data;
  } catch (error) {
    const status = error?.response?.status;
    const data = error?.response?.data || {};
    return {
      estado: "error",
      status,
      mensaje: data.mensaje || data.error || error.message || "Error al estimar",
    };
  }
};

// Ejecuta el corte (persiste + envia correos).
export const ejecutarCorteCobranza = async ({ periodo = null, observacion = null } = {}) => {
  try {
    const body = {};
    if (periodo) body.periodo = periodo;
    if (observacion) body.observacion = observacion;
    const response = await api.post("/api/billing/historial/cortar", body);
    return response.data;
  } catch (error) {
    const status = error?.response?.status;
    const data = error?.response?.data || {};
    return {
      estado: "error",
      status,
      mensaje: data.mensaje || data.error || error.message || "Error al ejecutar corte",
    };
  }
};

// Reintentar correo de notificacion de UN detalle especifico.
export const reintentarEmailDetalle = async (detalleId) => {
  try {
    const response = await api.post(
      `/api/billing/historial/detalle/${detalleId}/notificar-email`
    );
    return response.data;
  } catch (error) {
    const data = error?.response?.data || {};
    return {
      estado: "error",
      exito: false,
      mensaje: data.mensaje || data.error || error.message || "Error",
    };
  }
};
